import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "menus" }

import { useUserStore } from '@/store'
import { ref, watch } from 'vue'
import IconFont from './IconFont.jsx'
import { useRoute } from 'vue-router'
import { hasHiddenChildren } from '@/configs/route.config'


export default /*@__PURE__*/_defineComponent({
  __name: 'SiderMenu',
  setup(__props) {

const userStore = useUserStore()
const route = useRoute()

const list = userStore.roleRouters[0].children

const selectedKeys = ref<string[]>([])
const openKeys = ref<string[]>([])

const handleSelect = (e: unknown) => {
  console.log(e)
}

const updateRoute = () => {
  const { name, matched, meta } = route
  openKeys.value = []

  if (meta.isHidden) {
    selectedKeys.value = [`${meta.parent as string}`]
  } else {
    selectedKeys.value = [`${name as string}`]
  }

  const keys: string[] = []
  matched.filter(e => e.name !== name).forEach(e => {
    keys.push(e.name as string)
  })

  openKeys.value = keys

  if (keys.filter(e => hasHiddenChildren.includes(e)).length > 0) {
    selectedKeys.value = keys
  }
}

watch(route, () => {
  // console.log('路由变化', e)
  updateRoute()
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      selectedKeys: selectedKeys.value,
      "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event)),
      openKeys: openKeys.value,
      "onUpdate:openKeys": _cache[1] || (_cache[1] = ($event: any) => ((openKeys).value = $event)),
      mode: "inline",
      theme: "dark",
      onSelect: handleSelect
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (v) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: v.name
          }, [
            (v.children && v.children.length > 0)
              ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                  key: v.name
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(IconFont), {
                      type: v?.meta?.icon as string
                    }, null, 8, ["type"])
                  ]),
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(v?.meta?.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.children, (vv) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: vv.name
                      }, [
                        (!vv?.meta?.isHidden)
                          ? (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: vv.name
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_router_link, {
                                  to: vv.path
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(vv?.meta?.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    }, 8, ["selectedKeys", "openKeys"])
  ]))
}
}

})